import { Actions } from 'vuex-smart-module';
import { AlfaApiLoanApplicationStatusService } from '../services';
import AlfaApiLoanApplicationStatusesGetters from './getters';
import AlfaApiLoanApplicationStatusesMutations from './mutations';
import AlfaApiLoanApplicationStatusesState from './state';

const alfaApiLoanApplicationStatusService = new AlfaApiLoanApplicationStatusService();

export default class AlfaApiLoanApplicationStatusesActions extends Actions<
  AlfaApiLoanApplicationStatusesState,
  AlfaApiLoanApplicationStatusesGetters,
  AlfaApiLoanApplicationStatusesMutations,
  // eslint-disable-next-line no-use-before-define
  AlfaApiLoanApplicationStatusesActions
> {
  async get_statuses() {
    this.mutations.SET_LOADING(true);

    try {
      const data = await alfaApiLoanApplicationStatusService.get();

      this.mutations.SET_STATUSES(data);
    } catch (error) {
      console.log(error);
    } finally {
      this.mutations.SET_LOADING(false);
    }
  }
}
